/* eslint-disable no-undef */
import Icon from "@material-ui/core/Icon";
import { makeStyles } from "@material-ui/core/styles";
import Launch from "@material-ui/icons/Launch";
import { Grid, Typography } from "@mui/material";
import { useKeycloak } from "@react-keycloak/web";
import styles from "assets/jss/material-dashboard-pro-react/views/dashboardStyle.js";
import Card from "components/UI/Card/Card.js";
import CardFooter from "components/UI/Card/CardFooter.js";
import CardHeader from "components/UI/Card/CardHeader.js";
import CardIcon from "components/UI/Card/CardIcon.js";

import { useTranslation } from "react-i18next";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { useDashboardWorkItemStats } from "services/input-core/dashboard/get-dashboard--workitem-stats copy";
import { useDashboardStats } from "services/input-core/dashboard/get-dashboard-stats";
import ActivitiesRequiringActionCard from "./components/ActivitiesRequiringActionCard";
import ProcessListSection from "./components/ProcessListSection";
import { useDashboardActivityItemStats } from "services/input-core/dashboard/get-dashboard-activityItem-stats";
import { useSubscription } from "store/auth/auth-store";
import ReprocessMonitor from "./components/ReprocessMonitor";
import Monitor from "./components/Monitor";

const useStyles = makeStyles(styles as never);

export default function Dashboard() {
  const { t } = useTranslation("dashboard");
  const classes = useStyles();
  const { data: stats, isLoading: statsIsLoading } = useDashboardStats();
  const { keycloak } = useKeycloak();

  const { isKuo } = useSubscription();
  const hasSowProfile = keycloak.hasResourceRole("sowProfile", "uverify");
  const haveReprocessMonitor = keycloak?.hasResourceRole(
    "Reprocess Monitor",
    "uverify"
  );


  const {
    data: processes,
    isLoading: isProcessesLoading,
  } = useDashboardWorkItemStats();

  const {
    data: activityItemStats,
    isLoading: isActivityItemStatsLoading,
  } = useDashboardActivityItemStats();

  const showCardValue = (value: number | undefined) => {
    if (statsIsLoading) {
      return <Skeleton />;
    }

    return value;
  };


  return (
    <div id="dashboard-content">
      <Grid container spacing={2}>
        {hasSowProfile && (
          <Grid item xs={12} sm={12} md={6} id="sows-stat-card">
            <Card>
              <CardHeader color="info" stats icon>
                <CardIcon color="info">
                  <Icon>folder</Icon>
                </CardIcon>
                <p className={classes.cardCategory}>{t("sows")}</p>
                <h3 className={classes.cardTitle} id="sows-stat-card-count">
                  {showCardValue(stats?.sowCount)}
                </h3>
              </CardHeader>
              <CardFooter stats>
                <a
                  className={classes.stats}
                  href="sows/list"
                  id="sows-stat-card-link"
                >
                  <Typography color="primary">
                    <Launch />
                  </Typography>
                  {t("view-sows")}
                </a>
              </CardFooter>
            </Card>
          </Grid>
        )}
        <Grid
          item
          xs={12}
          sm={12}
          md={hasSowProfile ? 6 : 12}
          id="workers-stat-card"
        >
          <Card>
            <CardHeader color="success" stats icon>
              <CardIcon color="success">
                <Icon>groups</Icon>
              </CardIcon>
              <p className={classes.cardCategory}>{t("workers")}</p>
              <h3 className={classes.cardTitle} id="workers-stat-card-count">
                {showCardValue(stats?.workerCount)}
              </h3>
            </CardHeader>
            <CardFooter stats>
              <a
                className={classes.stats}
                href="workers/list"
                id="workers-stat-card-link"
              >
                <Typography color="primary">
                  <Launch />
                </Typography>
                {t("view-workers")}
              </a>
            </CardFooter>
          </Card>
        </Grid>
      </Grid>

      {!isKuo && (
        <Grid container>
          <Grid item xs={12} sm={12} md={12}>
            <ActivitiesRequiringActionCard color="info" icon={""} />
          </Grid>
        </Grid>
      )}

      <Grid container>
        <ProcessListSection
          activityItemStats={activityItemStats}
          processes={processes}
          isProcessesLoading={isProcessesLoading || isActivityItemStatsLoading}
        />
      </Grid>

      <Grid container spacing={2}>
        {haveReprocessMonitor && (
          <Grid item xs={12} sm={6} md={6}>
            <h3>{t("reprocess-monitor")}</h3>
            <ReprocessMonitor />
          </Grid>
        )}
        <Grid
          item
          xs={12}
          sm={haveReprocessMonitor ? 6 : 12}
          md={haveReprocessMonitor ? 6 : 12}
        >
          <h3>{t("expiration-monitor")}</h3>
          <Monitor />
        </Grid>
      </Grid>
    </div>
  );
}
